import {
  DataTable,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableSelectAll,
  TableHeader,
  TableBody,
  TableSelectRow,
  TableCell,
  FormLabel,
  TableToolbar,
  TableToolbarContent,
  TableToolbarSearch,
  InlineNotification,
} from "carbon-components-react";
import classNames from "classnames";
import _ from "lodash";
import { useEffect, useState } from "react";
import "./MultiSelect.scss";

// let selected = [];
// let allIds = [];
// const mode = "table";

const Multiselect = (props) => {
  const [tableRows, setTableRows] = useState([]);
  const [selected, setSelected] = useState([]);
  const [key, setKey] = useState("");
  const [initialized, setinitialized] = useState(false);
  const [ids, setIds] = useState([]);
  const [disabledItems, setDisabledItems] = useState([]);
  const [hiddenItems, setHiddenItems] = useState([]);
  const [toggled, setToggled] = useState([]);

  useEffect(() => {
    // checks if we have data
    // populates the underlyingArray only if it's empy
    // allIds = props.items.map((item) => item.id);
  }, [props.items]);

  useEffect(() => {
    // console.log("props.hiddenItems", props.hiddenItems)
    setHiddenItems(props.hiddenItems || [])
  }, [props.hiddenItems]);

  useEffect(() => {
    setDisabledItems(props.disabledItems || [])
  }, [props.disabledItems]);

  useEffect(() => {
    if (
      1
      // !initialized &&
      // !_.isEmpty(props.initialSelectedItem) &&
      // props.initialSelectedItem.length > 0
    ) {
      const selected_ = props.initialSelectedItem || []
      setSelected(selected_)
      props.onChange(selected_, true);
      let rows = props.items
      if (
        props.items
        && props.items.length > 0
      ) {
        if (
          hiddenItems
          && hiddenItems.length > 0
        ) {
          rows = props.items.filter(item => !hiddenItems.includes(item.id))
        }
        if (rows && rows.length > 0) {
          rows = rows.map((item) => {
            return {
              ...item,
              isSelected: (!_.isEmpty(selected_)) ? selected_.includes(item.id) : false,
            };
          })
        }
      }
      rows = sortSelectedFirst(rows)
      setTableRows(
        rows
      );
      setinitialized(true)
      setIds(props.items?.map((item) => item.id))

    }
  }, [props.initialSelectedItem, props.items, hiddenItems]);


  const sortSelectedFirst = (items) => {
    let result = []
    if (!items) {
      items = props.items
    }
    if (props.initialSelectedItem) {
      props.initialSelectedItem
        // .filter(item => {
        //   console.log("sortSelectedFirst", item, toggled)
        //   return (toggled) ? !toggled.includes(item.id) : true
        // })
        .forEach(function (key) {
          var found = false;
          items = items.filter(function (item) {
            if (!found &&
              item.id === key &&
              !toggled.includes(item.id)
            ) {
              result.push(item);
              found = true;
              return false;
            } else
              return true;
          })

        })
    }
    result = result.concat(items)
    return result
  }

  const toggleRow = (value, row) => {
    let newSelected = [...selected]
    if (value) {
      newSelected.push(row.id)
    } else {
      newSelected = newSelected.filter((item) => item !== row.id)

    }
    setToggled(toggled => [...toggled].concat(row.id))
    setSelected(newSelected)
    props.onChange(newSelected);
  };

  const toggleAll = (e, selectedRows) => {
    let newSelected = [...selected]
    if (e.target.checked && _.isEmpty(selectedRows)) {
      newSelected = ids.filter(item => {
        return !disabledItems.includes(item) && !hiddenItems.includes(item)
      });
    } else {
      newSelected = [];
    }
    // console.log("newSelected", selectedRows, newSelected)
    setSelected(newSelected)
    props.onChange(newSelected);
  };

  const content =
    (!_.isEmpty(tableRows)) ? (
      <div key={props.id}>
        <FormLabel>{props.labelText}</FormLabel>
        <DataTable rows={tableRows} headers={props.headers} key={"datatable-loaded-" + key}>
          {({
            getSelectionProps,
            getRowProps,
            getTableProps,
            getHeaderProps,
            onInputChange,
            selectedRows,
            rows,
            headers,
          }) => {
            /**
             * Override default onSelect function/property
             */
            const selectionProps = getSelectionProps();
            const newSelectionProps = {
              ...selectionProps,
              onSelect: (e) => {
                toggleAll(e, selectedRows);
                selectionProps.onSelect(e);
              },
            };
            return (
              <TableContainer
                className={classNames("multiselect-table multiselect-table__container",
                  {
                    "with-max-height": !props.disableMaxHeight
                  }
                )}
              >
                <TableToolbar>
                  <TableToolbarContent>
                    {/* pass in `onInputChange` change here to make filtering work */}
                    <TableToolbarSearch onChange={onInputChange} persistent={true} />
                  </TableToolbarContent>
                </TableToolbar>
                <Table
                  {...getTableProps()}
                  size="short"
                  className={classNames("multiselect-table")}
                >
                  <TableHead className={"multiselect-table__header"}>
                    <TableRow>
                      <TableSelectAll {...newSelectionProps} />
                      {headers.map((header, i) => (
                        <TableHeader key={i} {...getHeaderProps({ header })}>
                          {header.header}
                        </TableHeader>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody className={"multiselect-table__body"}>
                    {rows.map((row, index) => {
                      // console.log(row)
                      const tsDisabled = disabledItems.includes(row.id)

                      return (
                        <TableRow {...getRowProps({ row })} key={`table-row-${props.id}-${index}`}>
                          <TableSelectRow
                            {...getSelectionProps({ row })}
                            disabled={tsDisabled}
                            onChange={(e) => toggleRow(e, row)}
                          />
                          {row.cells.map((cell) => (
                            <TableCell key={cell.id}>{cell.value}</TableCell>
                          ))}
                        </TableRow>
                      )
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
            );
          }}
        </DataTable>
      </div>
    ) : (
      <InlineNotification
        kind="warning"
        lowContrast={true}
        title="The list is empty"
      />
    );

  return content;
};

export default Multiselect